/* eslint-disable react/destructuring-assignment */

const MobileModalCloseIconNew = (props: any) => {
  const fillClr = props.fillColor || 'var(--brand-bg-primary)';
  return (
    (<svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      data-palette="MobileModalCloseIconNew">
      <g fill="none" fillRule="evenodd">
        <g>
          <g>
            <g>
              <path
                d="M0 0L24 0 24 24 0 24z"
                transform="translate(-337 -280) translate(0 267) translate(337 13)"
              />
              <path
                fill={fillClr}
                fillRule="nonzero"
                d="M12 10.586L16.95 5.636 18.364 7.05 13.414 12 18.364 16.95 16.95 18.364 12 13.414 7.05 18.364 5.636 16.95 10.586 12 5.636 7.05 7.05 5.636z"
                transform="translate(-337 -280) translate(0 267) translate(337 13)"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>)
  );
};

export default MobileModalCloseIconNew;
